import MiMenu from './MiMenu.vue'

export default MiMenu
